import { AddStockAllocation, DeleteStockAllocation, DispatchEditListDto, EditStockAllocation } from "features/iot/stock-management/models/stock-management-models";
import { postRequest, putRequest, RequestDataType } from "services/api";


export const addStockAllocation = async (data: Partial<AddStockAllocation>) =>
  await postRequest(
    "/StockManagement/AddStockAllocation",
    data,
    RequestDataType.Entity
  );

export const editStockAllocation = async (data: Partial<EditStockAllocation>) =>
  await putRequest(
    "/StockManagement/EditStockAllocation",
    data,
    RequestDataType.Entity
  );

export const deleteStockAllocation = async (
  data: Partial<DeleteStockAllocation>
) =>
  await putRequest(
    "/StockManagement/DeleteStockAllocation",
    data,
    RequestDataType.Entity
  );

export const editDispatches = async (data: Partial<DispatchEditListDto>) =>
  await putRequest(
    "/StockManagement/PutDispatches",
    data,
    RequestDataType.Entity
  );
